import type { PublicClip } from "@kmstories/shared";
import { useEffect, useState } from "react";
import { Link } from "react-router";
import { EmailCapture } from "../components/EmailCapture.js";
import { useT } from "../i18n/LocaleProvider.js";
import { api } from "../lib/api.js";
import { useDocumentTitle } from "../lib/useDocumentTitle.js";

export function ClipsPage() {
  const { m, lp, locale } = useT();
  useDocumentTitle(m.meta.pages.clips);
  const [clips, setClips] = useState<PublicClip[] | null>(null);
  useEffect(() => {
    api.get<{ clips: PublicClip[] }>(`/api/clips?locale=${locale}`).then((r) => setClips(r.clips)).catch(() => setClips([]));
  }, [locale]);

  return (
    <div className="container">
      <div className="page-head">
        <h1>{m.clips.heading}</h1>
      </div>
      {clips === null ? (
        <p className="muted">{m.common.loading}…</p>
      ) : clips.length === 0 ? (
        <div className="empty">
          <p style={{ margin: 0 }}>{m.clips.empty}</p>
          <EmailCapture source="footer" buttonLabel={m.clips.emptyCta} compact />
        </div>
      ) : (
        <div className="clips-grid">
          {clips.map((c) => (
            <Link key={c.slug} className={`clip-card ${c.format === "short" ? "clip-card--short" : ""}`} to={lp(`/c/${c.slug}`)}>
              <img className="clip-card__thumb" src={c.thumbnailUrl} alt="" loading="lazy" />
              <span className="clip-card__title">{c.title}</span>
              {c.description && <span className="muted small">{c.description}</span>}
            </Link>
          ))}
        </div>
      )}
      <section className="section section--tight">
        <div className="card card--paper">
          <h2 style={{ fontSize: "1.3rem" }}>{m.clips.backToFilm}</h2>
          <Link className="btn btn--primary" to={lp("/share")}>
            {m.clips.shareCta}
          </Link>
        </div>
      </section>
    </div>
  );
}
